import React from "react";

import { Row, Col } from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import strings from "../../core/translate";
import MerchantSubItemModalAddUpdate from "./MerchantSubItemModalAddUpdate";

export default class MerchantSubItemAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      code: "",
      description: "",
      loading: false,
    };

    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const { selectedItem } = this.props.match.params;
    this.pathname = `merchants/{merchantId}/sub-items/${selectedItem}`;
    const edit = this.props.location.data;

    if (edit) {
      this.setState({
        ...edit,
      });
    }
  }

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const { id, code, description } = this.state;
    const { selectedItem } = this.props.match.params;

    try {
      let response;
      if (id) {
        response = await this.engine.updateItem(this.pathname, id, {
          code,
          description,
        });
      } else {
        response = await this.engine.saveItem(this.pathname, {
          code,
          description,
        });
      }

      if (response && (response.status === 201 || response.status === 200)) {
        this.props.history.push({
          pathname: `/admin/merchant/${selectedItem}/subitems`,
          state: { selectedItem },
        });
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        alert("Error: " + err.response.data.message.join(", "));
      } else {
        alert("An unexpected error occurred: " + err.message);
      }
    }

    this.setState({ loading: false });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    this.setState({ [name]: trimmedValue });
  };

  render() {
    const { loading, isLoading, code, description } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <h4>{strings.information}</h4>
        <Row>
          <Col md="12">
            <MerchantSubItemModalAddUpdate
              code={code}
              description={description}
              loading={loading}
              handleSubmit={this.handleValidSubmit}
              changeInput={this.handleInputChange}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
